import { z } from "zod";

export const ZGulvMotFriluftSchema = z.object({
  // 10
  isActive: z.boolean().default(false),
  tekst: z.string(),
  betongMedUnderliggendeIsolasjon: z.object({
    // 10.1
    isActive: z.boolean().default(false),
    tekst: z.string(),
    utenpaliggendeIsolasjon: z.object({
      // 10.1.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    nedforetBindingsverk: z.object({
      // 10.1.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
  selvberendeStalplatetak: z.object({
    // 10.2
    isActive: z.boolean().default(false),
    tekst: z.string(),
    overliggendeIsolasjon: z.object({
      // 10.2.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    utenpaliggendeIsolasjon: z.object({
      // 10.2.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    nedforetBindingsverk: z.object({
      // 10.2.3
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
  massivtre: z.object({
    // 10.3
    isActive: z.boolean().default(false),
    tekst: z.string(),
    overliggendeIsolasjon: z.object({
      // 10.3.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    utenpaliggendeIsolasjon: z.object({
      // 10.3.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    nedforetBindingsverk: z.object({
      // 10.3.3
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
});

export type IGulvMotFriluftSchema = z.infer<typeof ZGulvMotFriluftSchema>;
